import {
  ActionReducerMap,
  createFeatureSelector,
  MemoizedSelector
} from '@ngrx/store';

import * as fromShiftSettings from './shift-settings.reducer';

export interface ShiftState {
  shiftSettings: fromShiftSettings.ShiftState;
}

export const reducers: ActionReducerMap<ShiftState> = {
  shiftSettings: fromShiftSettings.reducer
};

export const getShiftState: MemoizedSelector<
  object,
  ShiftState
> = createFeatureSelector<ShiftState>('shiftSettings');
